import { Component, OnInit ,Input, Inject} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MyOrder, OrderHistory } from 'src/app/models/order';
import { OpenningHours, Restaurant } from 'src/app/models/restaurant';
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { OrdersService } from 'src/app/services/order-service';

import { DOCUMENT } from '@angular/common';

import { ServerResponse } from 'src/app/models/serverResponse';
import { DataService } from 'src/app/services/data.service';
import { PopupErrorComponent } from '../popup-error/popup-error.component';
import { PopupHistoryCanotRestoreComponent } from '../popup-historyCanotRestore/popup-historyCanotRestore.component';

@Component({
  selector: 'app-history-order-item',
  templateUrl: './history-order-item.component.html',
  styleUrls: ['./history-order-item.component.scss']
})
export class HistoryOrderItemComponent implements OnInit {
 require: any
 FileSaver = require('file-saver');
 @Input() orderItem:OrderHistory;
 showProgress=false;

  constructor( @Inject(DOCUMENT) private document: Document ,private router: Router,private proxy:AppProxy,private matDialog:MatDialog ,private orderService:OrdersService,private bussinssService: BussinssService ,private dataService:DataService) { }

  ngOnInit(): void {}

  orderAgain()
  {
    if(localStorage.SMS=="")
   this.proxy.showError("חובה להכניס קוד","");
   else if(localStorage.ACCESS_TOKEN  == "null"  || localStorage.SMS_CODE=="")
    this.router.navigate(['../mainHome']);
    else
    {
      this.showProgress=true;
    this.orderService.setNewOrderByHistory(this.orderItem.OrderID).subscribe((res:ServerResponse)=>{

      if(res.error==true)
      {
         this.showProgress=false;
        if(res.responseMessage=="missing items")
        this.matDialog.open(PopupHistoryCanotRestoreComponent);
      else
        this.proxy.showError("שגיאה באחזור הזמנה מההיסטוריה","");
       
      }
      if(res.error==false)
      {
      this.bussinssService.getRestaurantDetails(this.orderItem.RestaurantID,false,false,false,null,null).subscribe((restaurant:Restaurant)=>{
      if(restaurant.IsOpen == 1 && restaurant.IsTemporaryClosed == 0)
        { 
          this.dataService.updateYourOrder.next(true);
          this.router.navigate(["../yourOrder"]);
        }
      else
          this.proxy.showError("המסעדה סגורה\n אין אפשרות לבצע הזמנה","");
      this.showProgress=false;
      
    });
  }
});
}
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.matDialog.open(PopupErrorComponent, { disableClose: true });
  }

  downloadPdf() {
    const formattedDocLink = this.orderItem.DocLink.replace(/ /g, '');
    const url = new URL(formattedDocLink);

    if (url) {
      this.document.defaultView?.open(url.toString(), '_blank');
    } else {
      console.error('Invalid URL');
    }


   // this.orderService.getDownloadInvoice(this.orderItem.OrderID).subscribe((res:any)=>{
    //const pdfUrl = 'assets/sample.pdf';
    //const pdfName = 'your_pdf_file';
   // if(this.orderItem.ReceptionFile!=null)
  //  this.FileSaver.saveAs(this.orderItem.ReceptionFile, pdfName);
  //  else
    //this.proxy.showSucceeded("החשבונית נשלחה \n בהצלחה למייל שלך","");
   // });
  }
}
